// Catalogue des rapports de l'espace Super Admin.
// Chaque entrée décrit un rapport proposé ; la construction des lignes est
// réalisée dans buildReport.ts à partir des données réellement présentes dans
// les stores (comptes, patrimoine partagé, abonnements, paiements, territoire).

import type { ReportTypeDef } from "@/components/feature/reports/types";

export const SUPER_ADMIN_REPORT_TYPES: ReportTypeDef[] = [
  {
    id: "utilisateurs",
    label: "Rapport des utilisateurs",
    icon: "ri-group-line",
    description: "Tous les comptes de la plateforme avec type, statut, ville et formule.",
  },
  {
    id: "proprietaires",
    label: "Rapport des propriétaires",
    icon: "ri-user-star-line",
    description: "Comptes propriétaires et nombre d'immeubles rattachés.",
  },
  {
    id: "agences",
    label: "Rapport des agences",
    icon: "ri-building-2-line",
    description: "Comptes agences et patrimoine géré.",
  },
  {
    id: "immeubles",
    label: "Rapport des immeubles",
    icon: "ri-building-4-line",
    description: "Immeubles de la plateforme avec localisation et biens rattachés.",
  },
  {
    id: "biens",
    label: "Rapport des biens",
    icon: "ri-home-4-line",
    description: "Biens par type, immeuble, loyer et statut d'occupation.",
  },
  {
    id: "locataires",
    label: "Rapport des locataires",
    icon: "ri-user-3-line",
    description: "Répertoire des locataires et logements occupés.",
  },
  {
    id: "contrats",
    label: "Rapport des contrats",
    icon: "ri-file-text-line",
    description: "Contrats par période, loyer, caution et statut.",
  },
  {
    id: "abonnements",
    label: "Rapport des abonnements",
    icon: "ri-vip-diamond-line",
    description: "Abonnements par compte, formule, période et statut.",
  },
  {
    id: "paiements",
    label: "Rapport des paiements",
    icon: "ri-hand-coin-line",
    description: "Paiements d'abonnement par date, méthode, montant et statut.",
  },
  {
    id: "territoire",
    label: "Rapport territorial",
    icon: "ri-map-2-line",
    description: "Découpage territorial et nombre d'immeubles par région.",
  },
];